/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_2_Task_Plant_2_TypesInputs */

const en_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant 2 different types of trees`)
};

const ar_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ازرع شجرتين من نوعين مختلفين`)
};

const de_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 verschiedene Baumarten pflanzen`)
};

const es_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planta 2 tipos diferentes de árboles`)
};

const fr_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantez 2 types d'arbres différents`)
};

const it_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pianta 2 diversi tipi di alberi`)
};

const ja_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`異なる2種類の木を植える`)
};

const ko_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서로 다른 종류의 나무 2그루 심기`)
};

const pt_br_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plante 2 tipos diferentes de árvores`)
};

const ru_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посадите 2 разных вида деревьев`)
};

const th_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกต้นไม้ 2 ชนิดที่แตกต่างกัน`)
};

const tr_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 farklı türde ağaç dik`)
};

const zh_cn_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`种植 2 种不同植物`)
};

const zh_tw_phase_2_task_plant_2_types = /** @type {(inputs: Phase_2_Task_Plant_2_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種植 2 種不同的樹`)
};

/**
* | output |
* | --- |
* | "Plant 2 different types of trees" |
*
* @param {Phase_2_Task_Plant_2_TypesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_2_task_plant_2_types = /** @type {((inputs?: Phase_2_Task_Plant_2_TypesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_2_Task_Plant_2_TypesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_2_task_plant_2_types(inputs)
	if (locale === "ar") return ar_phase_2_task_plant_2_types(inputs)
	if (locale === "de") return de_phase_2_task_plant_2_types(inputs)
	if (locale === "es") return es_phase_2_task_plant_2_types(inputs)
	if (locale === "fr") return fr_phase_2_task_plant_2_types(inputs)
	if (locale === "it") return it_phase_2_task_plant_2_types(inputs)
	if (locale === "ja") return ja_phase_2_task_plant_2_types(inputs)
	if (locale === "ko") return ko_phase_2_task_plant_2_types(inputs)
	if (locale === "pt_br") return pt_br_phase_2_task_plant_2_types(inputs)
	if (locale === "ru") return ru_phase_2_task_plant_2_types(inputs)
	if (locale === "th") return th_phase_2_task_plant_2_types(inputs)
	if (locale === "tr") return tr_phase_2_task_plant_2_types(inputs)
	if (locale === "zh_cn") return zh_cn_phase_2_task_plant_2_types(inputs)
	return zh_tw_phase_2_task_plant_2_types(inputs)
});